const IconExpand = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 16H10V22H16V20.6667H11.3333V16ZM16 11.3333H20.6667V16H22V10H16V11.3333Z"
      fill={props?.fill || "#BBC4E0"}
    />
  </svg>
);

export default IconExpand;
